import { ResourceModel, format_useLabel } from '@modules/resource/resource.module'

import jobStatuses from '@server/constants/statuses/job-statuses'

const JobModel = new ResourceModel({
	resourceKey: 'job',
}, [
	{
		key: 'status',
		label: 'Status',
		type: 'select',
		fieldProps: {
			options: jobStatuses.map(status => ({
				label: status.label,
				value: status,
			})),
			showOnNew: false,
		},
		defaultValue: jobStatuses.find(s => s.key === 'live').order,
		required: 'always',
		toCSV: {
			formatValue: format_useLabel,
		}
	},
	{
		key: "client",
		label: "Client",
		type: 'resourceSelect',
		fieldProps: {
			resource: 'client',
			isMulti: false,
		},
		required: 'always',
	},
	// {
	// 	key: "positionHeldBy",
	// 	label: "Position Held By",
	// 	type: 'resourceSelect',
	// 	fieldProps: {
	// 		resource: 'candidate',
	// 	},
	// 	readOnly: true,
	// },
	{
		key: 'jobType',
		label: "Job Type",
		type: 'resourceSelect',
		fieldProps: {
			resource: 'jobtype',
			isMulti: false,
		},
		required: 'always',
	},
	{
		key: "startDate",
		label: "Start Date",
		type: 'date',
		required: 'always',
		fieldProps: {
			maxDate: new Date(9999, 12)
		}
	},
	{
		key: "createdAt",
		label: "Date Posted",
		type: 'date',
		readOnly: true,
	},
	{
		key: 'notes',
		label: 'Notes',
		type: 'textarea',
		required: 'never',
	},
	{
		key: 'timesheet',
		label: 'Timesheet',
		type: 'fieldArray',
		fieldProps: {
			component: 'TimesheetLineArray',
		},
		children: [],
		toCSV: {
			// TODO: add support for singular/plural
			include: 'never',
		},
		// TODO: add timesheetlinearray children
		// TODO: abstract to timesheetline field
	},
	{
		key: 'matchedCandidates',
		label: 'Matched Candidates',
		type: 'fieldArray',
		fieldProps: {
			component: 'MatchedCandidates',
			showOnNew: false,
		},
		children: [],
		toCSV: {
			include: 'never',
		}
		// TODO: add matchedCandidates children, account for non-editable fields
	},
])

// TODO: remove window instances after development
window.JobModel = JobModel;

export default JobModel



// WEBPACK FOOTER //
// ./src/modules/job/job.model.js